import { noOp } from 'common/Constants';
import { ClientEvents } from 'common/events/ClientEvents';
import React from 'react';
import { FaArrowTrendUp } from 'src/shared/design-system/FontAwesome';
import { useTracker } from 'src/shared/hooks/useTracker';
import { ResultButton, ResultText } from './styles';

interface TrendingSearchResultProps {
  onClick?: (searchTerm: string) => void;
  searchTerm: string;
}

export const TrendingSearchResult: React.FC<TrendingSearchResultProps> = ({ onClick = noOp, searchTerm }) => {
  const tracker = useTracker();

  return (
    <ResultButton
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
        tracker.track(ClientEvents.TRENDING_SEARCH_CLICK, {
          query: searchTerm,
        });
        onClick(searchTerm);
      }}>
      <FaArrowTrendUp />
      <ResultText>{searchTerm}</ResultText>
    </ResultButton>
  );
};
